import './App.css';
import Layout from "../src/containers/Layout";

function App() {
  return (
    <div className="App">
      <Layout></Layout>
    </div>
  );
}

export default App;
